// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextArea-module__font-s-10___haiid {
  font-size: 10px !important;
}

.TextArea-module__font-s-12___neC5x {
  font-size: 12px !important;
}

.TextArea-module__font-s-13___CLXQM {
  font-size: 13px !important;
}

.TextArea-module__font-s-14____Mcsg {
  font-size: 14px !important;
}

.TextArea-module__font-s-15___NeF5Y {
  font-size: 15px !important;
}

.TextArea-module__font-s-16___wpXnh {
  font-size: 16px !important;
}

.TextArea-module__font-s-18___Ybbnn {
  font-size: 18px !important;
}

.TextArea-module__font-s-20___vPvmo {
  font-size: 20px !important;
}

.TextArea-module__font-s-22___XdxLM {
  font-size: 22px !important;
}

.TextArea-module__font-s-28___x3rJI {
  font-size: 28px !important;
}

.TextArea-module__font-w-400___ZXkXx {
  font-weight: 400 !important;
}

.TextArea-module__font-w-500___fER8R {
  font-weight: 500 !important;
}

.TextArea-module__font-w-600___icKn_ {
  font-weight: 600 !important;
}

.TextArea-module__font-w-700___CVE0l {
  font-weight: 700 !important;
}

.TextArea-module__p-5___tiBHF {
  padding: 5px !important;
}

.TextArea-module__p-12___ZQW4s {
  padding: 12px !important;
}

.TextArea-module__p-16___YOlvk {
  padding: 16px !important;
}

.TextArea-module__p-30___aobBZ {
  padding: 30px !important;
}

.TextArea-module__p-b-0___dBI72 {
  padding-bottom: 0 !important;
}

.TextArea-module__p-b-5____WcI8 {
  padding-bottom: 5px !important;
}

.TextArea-module__p-b-10___P0Opa {
  padding-bottom: 10px !important;
}

.TextArea-module__p-b-12___BwqTk {
  padding-bottom: 12px !important;
}

.TextArea-module__p-b-16___BTLU6 {
  padding-bottom: 16px !important;
}

.TextArea-module__p-b-18___DzcQI {
  padding-bottom: 18px !important;
}

.TextArea-module__p-b-20___m7y91 {
  padding-bottom: 20px !important;
}

.TextArea-module__p-b-25___BAgPg {
  padding-bottom: 25px !important;
}

.TextArea-module__p-b-30___J_brD {
  padding-bottom: 30px !important;
}

.TextArea-module__p-b-50___tR9LO {
  padding-bottom: 50px !important;
}

.TextArea-module__p-t-0___jyfzL {
  padding-top: 0 !important;
}

.TextArea-module__p-t-12___hY2ra {
  padding-top: 12px !important;
}

.TextArea-module__p-t-16___QXzkn {
  padding-top: 16px !important;
}

.TextArea-module__p-t-18___UFSau {
  padding-top: 18px !important;
}

.TextArea-module__p-t-20___fIksx {
  padding-top: 20px !important;
}

.TextArea-module__p-t-30___EbB0P {
  padding-top: 30px !important;
}

.TextArea-module__p-t-40___pivsl {
  padding-top: 40px !important;
}

.TextArea-module__p-t-50___RQYpd {
  padding-top: 50px !important;
}

.TextArea-module__p-l-20___JQMAr {
  padding-left: 20px !important;
}

.TextArea-module__p-l-30___WRDU0 {
  padding-left: 30px !important;
}

.TextArea-module__p-l-40___c0g81 {
  padding-left: 40px !important;
}

.TextArea-module__p-r-16___OWH4Y {
  padding-right: 16px !important;
}

.TextArea-module__p-r-20___QENNR {
  padding-right: 20px !important;
}

.TextArea-module__p-r-30___S8hgl {
  padding-right: 30px !important;
}

.TextArea-module__p-r-50___HB7W2 {
  padding-right: 50px !important;
}

.TextArea-module__p-r-60___KuGIX {
  padding-right: 60px !important;
}

.TextArea-module__m-b-1___wcNAm {
  margin-bottom: 1px !important;
}

.TextArea-module__m-b-2___Z7an6 {
  margin-bottom: 2px !important;
}

.TextArea-module__m-b-6___eLjxS {
  margin-bottom: 6px !important;
}

.TextArea-module__m-b-8___H2yv2 {
  margin-bottom: 8px !important;
}

.TextArea-module__m-b-10___zwaFy {
  margin-bottom: 10px !important;
}

.TextArea-module__m-b-14___kvxHP {
  margin-bottom: 14px !important;
}

.TextArea-module__m-b-16___LXVdr {
  margin-bottom: 16px !important;
}

.TextArea-module__m-b-20___ylHxJ {
  margin-bottom: 20px !important;
}

.TextArea-module__m-b-22___jgO4k {
  margin-bottom: 22px !important;
}

.TextArea-module__m-b-24___dAs3w {
  margin-bottom: 24px !important;
}

.TextArea-module__m-b-30___kqlTn {
  margin-bottom: 30px !important;
}

.TextArea-module__m-b-32___u2J5o {
  margin-bottom: 32px !important;
}

.TextArea-module__m-b-40___Z8CWw {
  margin-bottom: 40px !important;
}

.TextArea-module__m-t-2___mGJYI {
  margin-top: 2px !important;
}

.TextArea-module__m-t-3___aCRSl {
  margin-top: 3px !important;
}

.TextArea-module__m-t-4___HhfAV {
  margin-top: 4px !important;
}

.TextArea-module__m-t-5___GL41W {
  margin-top: 5px !important;
}

.TextArea-module__m-t-8___GAeav {
  margin-top: 8px !important;
}

.TextArea-module__m-t-10___n9u60 {
  margin-top: 10px !important;
}

.TextArea-module__m-t-15___W_Uwa {
  margin-top: 15px !important;
}

.TextArea-module__m-t-16___mukRE {
  margin-top: 16px !important;
}

.TextArea-module__m-t-20___IJQ9E {
  margin-top: 20px !important;
}

.TextArea-module__m-t-22___og6NQ {
  margin-top: 22px !important;
}

.TextArea-module__m-t-30___Ccu6u {
  margin-top: 30px !important;
}

.TextArea-module__m-t-32___AnvPX {
  margin-top: 32px !important;
}

.TextArea-module__m-l-auto___YnXxj {
  margin-left: auto !important;
}

.TextArea-module__m-l-4___tbW7Y {
  margin-left: 4px !important;
}

.TextArea-module__m-l-5___s5N6Z {
  margin-left: 5px !important;
}

.TextArea-module__m-l-6___F9r6B {
  margin-left: 6px !important;
}

.TextArea-module__m-l-8___XUqu6 {
  margin-left: 8px !important;
}

.TextArea-module__m-l-10___EQ4nF {
  margin-left: 10px !important;
}

.TextArea-module__m-l-16___rBMhE {
  margin-left: 16px !important;
}

.TextArea-module__m-l-20___MYgOu {
  margin-left: 20px !important;
}

.TextArea-module__m-l-24___Dim_J {
  margin-left: 24px !important;
}

.TextArea-module__m-l-30____A6ba {
  margin-left: 30px !important;
}

.TextArea-module__m-l-35___kzxsE {
  margin-left: 35px !important;
}

.TextArea-module__m-l-40___JlRMd {
  margin-left: 40px !important;
}

.TextArea-module__m-r-8___byJEO {
  margin-right: 8px !important;
}

.TextArea-module__m-r-10___jJGVX {
  margin-right: 10px !important;
}

.TextArea-module__m-r-16___bUnMi {
  margin-right: 16px !important;
}

.TextArea-module__m-r-20___fW_fx {
  margin-right: 20px !important;
}

.TextArea-module__m-r-24___O78Yg {
  margin-right: 24px !important;
}

.TextArea-module__m-r-30___R0vvJ {
  margin-right: 30px !important;
}

.TextArea-module__m-r-40___PMVFX {
  margin-right: 40px !important;
}

.TextArea-module__border-r-3___yywEV {
  border-radius: 3px !important;
}

.TextArea-module__border-r-4___C78VU {
  border-radius: 4px !important;
}

.TextArea-module__border-r-6___lT_4f {
  border-radius: 6px !important;
}

.TextArea-module__border-r-10___QhxBT {
  border-radius: 10px !important;
}

.TextArea-module__border-r-12___jZwNH {
  border-radius: 12px !important;
}

.TextArea-module__border-r-16___WIVxM {
  border-radius: 16px !important;
}

.TextArea-module__border-r-50___nQgPj {
  border-radius: 50% !important;
}

.TextArea-module__primary-border___nLKTS {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.TextArea-module__primary-border-b___V2i2X {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.TextArea-module__primary-border-t___xtHy5 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.TextArea-module__primary-border-l___OZgP7 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.TextArea-module__primary-border-r___KzgMc {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.TextArea-module__secondary-border___YRr01 {
  border: 1px solid #637768;
}

.TextArea-module__secondary-border-b___vQNP8 {
  border-bottom: 1px solid #637768;
}

.TextArea-module__secondary-border-t___cZi3t {
  border-top: 1px solid #637768;
}

.TextArea-module__secondary-border-l___sZh3y {
  border-left: 1px solid #637768;
}

.TextArea-module__secondary-border-r___mumIp {
  border-right: 1px solid #637768;
}

.TextArea-module__gap-0___lahf9 {
  gap: 0 !important;
}

.TextArea-module__gap-2___icwa8 {
  gap: 2px !important;
}

.TextArea-module__gap-4___mZzZt {
  gap: 4px !important;
}

.TextArea-module__gap-5___dt1Q8 {
  gap: 5px !important;
}

.TextArea-module__gap-6___jkfjL {
  gap: 6px !important;
}

.TextArea-module__gap-8___kIxVI {
  gap: 8px !important;
}

.TextArea-module__gap-10___qSWvc {
  gap: 10px !important;
}

.TextArea-module__gap-12___ECsNn {
  gap: 12px !important;
}

.TextArea-module__gap-14___Z1rnq {
  gap: 14px !important;
}

.TextArea-module__gap-16___qsTR8 {
  gap: 16px !important;
}

.TextArea-module__gap-18___ykeeU {
  gap: 18px !important;
}

.TextArea-module__gap-20___uSj_c {
  gap: 20px !important;
}

.TextArea-module__gap-24___OUG_I {
  gap: 24px !important;
}

.TextArea-module__gap-26___nGYw5 {
  gap: 26px !important;
}

.TextArea-module__gap-30___jDKkV {
  gap: 30px !important;
}

.TextArea-module__gap-32___dHImh {
  gap: 32px !important;
}

.TextArea-module__gap-40___AjmYz {
  gap: 40px !important;
}

.TextArea-module__gap-50___bnxCk {
  gap: 50px !important;
}

.TextArea-module__flex-1___cXSDd {
  flex: 1;
}

.TextArea-module__flex-none___pScPY {
  flex: none !important;
}

.TextArea-module__flex-column___fkWgL {
  display: flex;
  flex-direction: column !important;
}

.TextArea-module__flex-row___XZmAa {
  display: flex;
  flex-direction: row !important;
}

.TextArea-module__vertically-centered___HQC5S {
  display: flex;
  align-items: center !important;
}

.TextArea-module__horizontally-centered___w2lCU {
  display: flex;
  justify-content: center !important;
}

.TextArea-module__horizontally-end___ZoK99 {
  display: flex;
  justify-content: end !important;
}

.TextArea-module__vertically-start___ZklwD {
  display: flex;
  align-items: start !important;
}

.TextArea-module__space-between___G3qr2 {
  display: flex;
  justify-content: space-between !important;
}

.TextArea-module__flex-wrap___gPn1v {
  flex-wrap: wrap !important;
}

.TextArea-module__height-100___kLeer {
  height: 100%;
}

.TextArea-module__width-50___vhuxu {
  width: 50% !important;
}

.TextArea-module__width-100___m_IFS {
  width: 100%;
}

.TextArea-module__cursor-pointer___V7JPs {
  cursor: pointer;
}

.TextArea-module__cursor-not-allowed___XKwgX {
  cursor: not-allowed !important;
}

.TextArea-module__absolute-centered___qgdkz {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.TextArea-module__absolute___CewYx {
  position: absolute;
}

.TextArea-module__relative___zNcDo {
  position: relative;
}

.TextArea-module__fixed___zntxl {
  position: fixed;
}

.TextArea-module__visible___jSpG0 {
  opacity: 1;
}

.TextArea-module__invisible___ZV0jJ {
  opacity: 0;
}

.TextArea-module__col-90___La1To {
  width: 90% !important;
}

.TextArea-module__col-auto___G6WUh {
  width: auto !important;
}

.TextArea-module__medical-tabs___gvTkC {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.TextArea-module__medical-table-new___kumRa {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TextArea-module__medical-table-new___kumRa:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TextArea-module__medical-table-new___kumRa::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TextArea-module__medical-table-new___kumRa::-webkit-scrollbar-track {
  display: none;
}
.TextArea-module__medical-table-new___kumRa.TextArea-module__no-pagination___ocRs2 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TextArea-module__medical-table-new___kumRa.TextArea-module__no-pagination___ocRs2:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TextArea-module__medical-table-new___kumRa.TextArea-module__no-pagination___ocRs2::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TextArea-module__medical-table-new___kumRa.TextArea-module__no-pagination___ocRs2::-webkit-scrollbar-track {
  display: none;
}

.TextArea-module__medical-table-empty___SRLYG {
  padding: 14px 40px !important;
}

.TextArea-module__icon-btn___MTiPA {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.TextArea-module__search-icon___vL0Kp {
  width: 24px;
  height: 24px;
  align-self: center;
}

.TextArea-module__disable-select___fHDSw {
  user-select: none;
}

.TextArea-module__break-word___z0UJM {
  word-break: break-word;
}

.TextArea-module__popup-clear-btn___w6Ss6 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.TextArea-module__scroll-m-b-20___STvNi {
  scroll-margin-bottom: 20px;
}

.TextArea-module__label___QLYN9 {
  color: #637768;
}
.TextArea-module__label___QLYN9.TextArea-module__withError___IHE0g {
  color: #db2828;
}

.TextArea-module__readOnly___UT39f {
  color: #375844;
  white-space: break-spaces;
}

.TextArea-module__textAreaContainer___hZKIN {
  position: relative;
  display: flex;
}
.TextArea-module__textAreaContainer___hZKIN .TextArea-module__textArea___gi1Oc {
  font-family: var(--font-family);
  font-weight: 400;
  border-color: #375844;
  color: #375844;
  line-height: 20px;
  padding: 10px;
  flex: 1;
}
.TextArea-module__textAreaContainer___hZKIN .TextArea-module__textArea___gi1Oc.TextArea-module__withError___IHE0g {
  color: #db2828;
  border-color: #db2828;
  background-color: rgba(219, 40, 40, 0.1);
}
.TextArea-module__textAreaContainer___hZKIN .TextArea-module__textArea___gi1Oc.TextArea-module__withError___IHE0g::placeholder {
  color: #db2828;
  opacity: 0.5;
}
.TextArea-module__textAreaContainer___hZKIN .TextArea-module__textArea___gi1Oc::placeholder {
  color: #d3d3d3;
}
.TextArea-module__textAreaContainer___hZKIN .TextArea-module__textArea___gi1Oc:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: transparent;
}
.TextArea-module__textAreaContainer___hZKIN .TextArea-module__textArea___gi1Oc:disabled::placeholder {
  opacity: 0.4;
}
.TextArea-module__textAreaContainer___hZKIN .TextArea-module__templateModal___Y73T4 {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: white;
  border: 1px solid #f2f2f2;
  border-radius: 8px;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 5px;
}
.TextArea-module__textAreaContainer___hZKIN .TextArea-module__templateModal___Y73T4 .TextArea-module__option___dXkFQ {
  padding: 10px;
  cursor: pointer;
  font-size: 14px;
  color: #637768;
  transition: background-color 0.2s ease;
}
.TextArea-module__textAreaContainer___hZKIN .TextArea-module__templateModal___Y73T4 .TextArea-module__option___dXkFQ.TextArea-module__selected___T3Psh {
  background-color: #f0f0f0;
}
.TextArea-module__textAreaContainer___hZKIN .TextArea-module__templateModal___Y73T4 .TextArea-module__option___dXkFQ:hover {
  background-color: #f0f0f0;
}
.TextArea-module__textAreaContainer___hZKIN .TextArea-module__templateModal___Y73T4 .TextArea-module__option___dXkFQ:active {
  background-color: #e0e0e0;
}

.TextArea-module__error___urhVB {
  color: #db2828;
  min-height: 15px;
}

.TextArea-module__noBorder___nbcq9 {
  border: none !important;
  outline: none;
  box-shadow: none;
}

.TextArea-module__disabled___iLr1k {
  opacity: 0.6;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/TextArea/TextArea.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;AA8pBF;AA5pBE;EACE,cAAA;AA8pBJ;;AA1pBA;EACE,cAAA;EACA,yBAAA;AA6pBF;;AA1pBA;EACE,kBAAA;EACA,aAAA;AA6pBF;AA3pBE;EEOA,+BApBO;EAqBP,gBAFmD;EFJjD,qBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,OAAA;AA8pBJ;AA5pBI;EACE,cAAA;EACA,qBAAA;EACA,wCAAA;AA8pBN;AA5pBM;EACE,cAAA;EACA,YAAA;AA8pBR;AA1pBI;EACE,cAAA;AA4pBN;AAzpBI;EACE,YAAA;EACA,mBAAA;EACA,6BAAA;AA2pBN;AAzpBM;EACE,YAAA;AA2pBR;AAtpBE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wCAAA;EACA,eAAA;AAwpBJ;AAtpBI;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,sCAAA;AAwpBN;AAtpBM;EACE,yBAAA;AAwpBR;AArpBM;EACE,yBAAA;AAupBR;AAppBM;EACE,yBAAA;AAspBR;;AAhpBA;EACE,cAAA;EACA,gBAAA;AAmpBF;;AAhpBA;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;AAmpBF;;AAhpBA;EACE,YAAA;EACA,mBAAA;AAmpBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.label {\n  color: get-color(greenNew, medium-dark);\n\n  &.withError {\n    color: get-color(redNew, medium);\n  }\n}\n\n.readOnly {\n  color: get-color(greenNew, dark);\n  white-space: break-spaces;\n}\n\n.textAreaContainer {\n  position: relative;\n  display: flex;\n\n  .textArea {\n    @include get-font();\n    border-color: get-color(greenNew, dark);\n    color: get-color(greenNew, dark);\n    line-height: 20px;\n    padding: 10px;\n    flex: 1;\n\n    &.withError {\n      color: get-color(redNew, medium);\n      border-color: get-color(redNew, medium);\n      background-color: get-color(redNew, light);\n\n      &::placeholder {\n        color: get-color(redNew, medium);\n        opacity: 0.5;\n      }\n    }\n\n    &::placeholder {\n      color: get-color(gray, base);\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n      background-color: transparent;\n\n      &::placeholder {\n        opacity: 0.4;\n      }\n    }\n  }\n\n  .templateModal {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    z-index: 10;\n    background-color: white;\n    border: 1px solid get-color(gray, lightest);\n    border-radius: 8px;\n    max-height: 200px;\n    overflow-y: auto;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    margin-top: 5px;\n\n    .option {\n      padding: 10px;\n      cursor: pointer;\n      font-size: 14px;\n      color: get-color(greenNew, medium-dark);\n      transition: background-color 0.2s ease;\n\n      &.selected {\n        background-color: #f0f0f0;\n      }\n\n      &:hover {\n        background-color: #f0f0f0;\n      }\n\n      &:active {\n        background-color: #e0e0e0;\n      }\n    }\n  }\n}\n\n.error {\n  color: get-color(redNew, medium);\n  min-height: 15px;\n}\n\n.noBorder {\n  border: none !important;\n  outline: none;\n  box-shadow: none;\n}\n\n.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `TextArea-module__font-s-10___haiid`,
	"fontS12": `TextArea-module__font-s-12___neC5x`,
	"fontS13": `TextArea-module__font-s-13___CLXQM`,
	"fontS14": `TextArea-module__font-s-14____Mcsg`,
	"fontS15": `TextArea-module__font-s-15___NeF5Y`,
	"fontS16": `TextArea-module__font-s-16___wpXnh`,
	"fontS18": `TextArea-module__font-s-18___Ybbnn`,
	"fontS20": `TextArea-module__font-s-20___vPvmo`,
	"fontS22": `TextArea-module__font-s-22___XdxLM`,
	"fontS28": `TextArea-module__font-s-28___x3rJI`,
	"fontW400": `TextArea-module__font-w-400___ZXkXx`,
	"fontW500": `TextArea-module__font-w-500___fER8R`,
	"fontW600": `TextArea-module__font-w-600___icKn_`,
	"fontW700": `TextArea-module__font-w-700___CVE0l`,
	"p5": `TextArea-module__p-5___tiBHF`,
	"p12": `TextArea-module__p-12___ZQW4s`,
	"p16": `TextArea-module__p-16___YOlvk`,
	"p30": `TextArea-module__p-30___aobBZ`,
	"pB0": `TextArea-module__p-b-0___dBI72`,
	"pB5": `TextArea-module__p-b-5____WcI8`,
	"pB10": `TextArea-module__p-b-10___P0Opa`,
	"pB12": `TextArea-module__p-b-12___BwqTk`,
	"pB16": `TextArea-module__p-b-16___BTLU6`,
	"pB18": `TextArea-module__p-b-18___DzcQI`,
	"pB20": `TextArea-module__p-b-20___m7y91`,
	"pB25": `TextArea-module__p-b-25___BAgPg`,
	"pB30": `TextArea-module__p-b-30___J_brD`,
	"pB50": `TextArea-module__p-b-50___tR9LO`,
	"pT0": `TextArea-module__p-t-0___jyfzL`,
	"pT12": `TextArea-module__p-t-12___hY2ra`,
	"pT16": `TextArea-module__p-t-16___QXzkn`,
	"pT18": `TextArea-module__p-t-18___UFSau`,
	"pT20": `TextArea-module__p-t-20___fIksx`,
	"pT30": `TextArea-module__p-t-30___EbB0P`,
	"pT40": `TextArea-module__p-t-40___pivsl`,
	"pT50": `TextArea-module__p-t-50___RQYpd`,
	"pL20": `TextArea-module__p-l-20___JQMAr`,
	"pL30": `TextArea-module__p-l-30___WRDU0`,
	"pL40": `TextArea-module__p-l-40___c0g81`,
	"pR16": `TextArea-module__p-r-16___OWH4Y`,
	"pR20": `TextArea-module__p-r-20___QENNR`,
	"pR30": `TextArea-module__p-r-30___S8hgl`,
	"pR50": `TextArea-module__p-r-50___HB7W2`,
	"pR60": `TextArea-module__p-r-60___KuGIX`,
	"mB1": `TextArea-module__m-b-1___wcNAm`,
	"mB2": `TextArea-module__m-b-2___Z7an6`,
	"mB6": `TextArea-module__m-b-6___eLjxS`,
	"mB8": `TextArea-module__m-b-8___H2yv2`,
	"mB10": `TextArea-module__m-b-10___zwaFy`,
	"mB14": `TextArea-module__m-b-14___kvxHP`,
	"mB16": `TextArea-module__m-b-16___LXVdr`,
	"mB20": `TextArea-module__m-b-20___ylHxJ`,
	"mB22": `TextArea-module__m-b-22___jgO4k`,
	"mB24": `TextArea-module__m-b-24___dAs3w`,
	"mB30": `TextArea-module__m-b-30___kqlTn`,
	"mB32": `TextArea-module__m-b-32___u2J5o`,
	"mB40": `TextArea-module__m-b-40___Z8CWw`,
	"mT2": `TextArea-module__m-t-2___mGJYI`,
	"mT3": `TextArea-module__m-t-3___aCRSl`,
	"mT4": `TextArea-module__m-t-4___HhfAV`,
	"mT5": `TextArea-module__m-t-5___GL41W`,
	"mT8": `TextArea-module__m-t-8___GAeav`,
	"mT10": `TextArea-module__m-t-10___n9u60`,
	"mT15": `TextArea-module__m-t-15___W_Uwa`,
	"mT16": `TextArea-module__m-t-16___mukRE`,
	"mT20": `TextArea-module__m-t-20___IJQ9E`,
	"mT22": `TextArea-module__m-t-22___og6NQ`,
	"mT30": `TextArea-module__m-t-30___Ccu6u`,
	"mT32": `TextArea-module__m-t-32___AnvPX`,
	"mLAuto": `TextArea-module__m-l-auto___YnXxj`,
	"mL4": `TextArea-module__m-l-4___tbW7Y`,
	"mL5": `TextArea-module__m-l-5___s5N6Z`,
	"mL6": `TextArea-module__m-l-6___F9r6B`,
	"mL8": `TextArea-module__m-l-8___XUqu6`,
	"mL10": `TextArea-module__m-l-10___EQ4nF`,
	"mL16": `TextArea-module__m-l-16___rBMhE`,
	"mL20": `TextArea-module__m-l-20___MYgOu`,
	"mL24": `TextArea-module__m-l-24___Dim_J`,
	"mL30": `TextArea-module__m-l-30____A6ba`,
	"mL35": `TextArea-module__m-l-35___kzxsE`,
	"mL40": `TextArea-module__m-l-40___JlRMd`,
	"mR8": `TextArea-module__m-r-8___byJEO`,
	"mR10": `TextArea-module__m-r-10___jJGVX`,
	"mR16": `TextArea-module__m-r-16___bUnMi`,
	"mR20": `TextArea-module__m-r-20___fW_fx`,
	"mR24": `TextArea-module__m-r-24___O78Yg`,
	"mR30": `TextArea-module__m-r-30___R0vvJ`,
	"mR40": `TextArea-module__m-r-40___PMVFX`,
	"borderR3": `TextArea-module__border-r-3___yywEV`,
	"borderR4": `TextArea-module__border-r-4___C78VU`,
	"borderR6": `TextArea-module__border-r-6___lT_4f`,
	"borderR10": `TextArea-module__border-r-10___QhxBT`,
	"borderR12": `TextArea-module__border-r-12___jZwNH`,
	"borderR16": `TextArea-module__border-r-16___WIVxM`,
	"borderR50": `TextArea-module__border-r-50___nQgPj`,
	"primaryBorder": `TextArea-module__primary-border___nLKTS`,
	"primaryBorderB": `TextArea-module__primary-border-b___V2i2X`,
	"primaryBorderT": `TextArea-module__primary-border-t___xtHy5`,
	"primaryBorderL": `TextArea-module__primary-border-l___OZgP7`,
	"primaryBorderR": `TextArea-module__primary-border-r___KzgMc`,
	"secondaryBorder": `TextArea-module__secondary-border___YRr01`,
	"secondaryBorderB": `TextArea-module__secondary-border-b___vQNP8`,
	"secondaryBorderT": `TextArea-module__secondary-border-t___cZi3t`,
	"secondaryBorderL": `TextArea-module__secondary-border-l___sZh3y`,
	"secondaryBorderR": `TextArea-module__secondary-border-r___mumIp`,
	"gap0": `TextArea-module__gap-0___lahf9`,
	"gap2": `TextArea-module__gap-2___icwa8`,
	"gap4": `TextArea-module__gap-4___mZzZt`,
	"gap5": `TextArea-module__gap-5___dt1Q8`,
	"gap6": `TextArea-module__gap-6___jkfjL`,
	"gap8": `TextArea-module__gap-8___kIxVI`,
	"gap10": `TextArea-module__gap-10___qSWvc`,
	"gap12": `TextArea-module__gap-12___ECsNn`,
	"gap14": `TextArea-module__gap-14___Z1rnq`,
	"gap16": `TextArea-module__gap-16___qsTR8`,
	"gap18": `TextArea-module__gap-18___ykeeU`,
	"gap20": `TextArea-module__gap-20___uSj_c`,
	"gap24": `TextArea-module__gap-24___OUG_I`,
	"gap26": `TextArea-module__gap-26___nGYw5`,
	"gap30": `TextArea-module__gap-30___jDKkV`,
	"gap32": `TextArea-module__gap-32___dHImh`,
	"gap40": `TextArea-module__gap-40___AjmYz`,
	"gap50": `TextArea-module__gap-50___bnxCk`,
	"flex1": `TextArea-module__flex-1___cXSDd`,
	"flexNone": `TextArea-module__flex-none___pScPY`,
	"flexColumn": `TextArea-module__flex-column___fkWgL`,
	"flexRow": `TextArea-module__flex-row___XZmAa`,
	"verticallyCentered": `TextArea-module__vertically-centered___HQC5S`,
	"horizontallyCentered": `TextArea-module__horizontally-centered___w2lCU`,
	"horizontallyEnd": `TextArea-module__horizontally-end___ZoK99`,
	"verticallyStart": `TextArea-module__vertically-start___ZklwD`,
	"spaceBetween": `TextArea-module__space-between___G3qr2`,
	"flexWrap": `TextArea-module__flex-wrap___gPn1v`,
	"height100": `TextArea-module__height-100___kLeer`,
	"width50": `TextArea-module__width-50___vhuxu`,
	"width100": `TextArea-module__width-100___m_IFS`,
	"cursorPointer": `TextArea-module__cursor-pointer___V7JPs`,
	"cursorNotAllowed": `TextArea-module__cursor-not-allowed___XKwgX`,
	"absoluteCentered": `TextArea-module__absolute-centered___qgdkz`,
	"absolute": `TextArea-module__absolute___CewYx`,
	"relative": `TextArea-module__relative___zNcDo`,
	"fixed": `TextArea-module__fixed___zntxl`,
	"visible": `TextArea-module__visible___jSpG0`,
	"invisible": `TextArea-module__invisible___ZV0jJ`,
	"col90": `TextArea-module__col-90___La1To`,
	"colAuto": `TextArea-module__col-auto___G6WUh`,
	"medicalTabs": `TextArea-module__medical-tabs___gvTkC`,
	"medicalTableNew": `TextArea-module__medical-table-new___kumRa`,
	"noPagination": `TextArea-module__no-pagination___ocRs2`,
	"medicalTableEmpty": `TextArea-module__medical-table-empty___SRLYG`,
	"iconBtn": `TextArea-module__icon-btn___MTiPA`,
	"searchIcon": `TextArea-module__search-icon___vL0Kp`,
	"disableSelect": `TextArea-module__disable-select___fHDSw`,
	"breakWord": `TextArea-module__break-word___z0UJM`,
	"popupClearBtn": `TextArea-module__popup-clear-btn___w6Ss6`,
	"scrollMB20": `TextArea-module__scroll-m-b-20___STvNi`,
	"label": `TextArea-module__label___QLYN9`,
	"withError": `TextArea-module__withError___IHE0g`,
	"readOnly": `TextArea-module__readOnly___UT39f`,
	"textAreaContainer": `TextArea-module__textAreaContainer___hZKIN`,
	"textArea": `TextArea-module__textArea___gi1Oc`,
	"templateModal": `TextArea-module__templateModal___Y73T4`,
	"option": `TextArea-module__option___dXkFQ`,
	"selected": `TextArea-module__selected___T3Psh`,
	"error": `TextArea-module__error___urhVB`,
	"noBorder": `TextArea-module__noBorder___nbcq9`,
	"disabled": `TextArea-module__disabled___iLr1k`
};
module.exports = ___CSS_LOADER_EXPORT___;
